import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { RouterLink } from '@angular/router';
import { TranslatePipe } from '@ngx-translate/core';
import { MatIcon } from '@angular/material/icon';

@Component({
  selector: 'app-nav-tile',
  imports: [RouterLink, TranslatePipe, MatIcon],
  templateUrl: './nav-tile.component.html',
  styleUrl: './nav-tile.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NavTileComponent {
  link = input.required<string>();
  icon = input.required<string>();
  titleKey = input.required<string>();
  subtitleKey = input.required<string>();
  statLabelKey = input<string | undefined>(undefined);
  statValue = input<number | null>(null);
}
